import { c as _c } from "react/compiler-runtime";
import { postEntitiesSearch } from '@onefootprint/fetch-dashboard';
import { getErrorMessage } from '@onefootprint/request';
import type { VaultKind } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import useEntitiesQueryParams from '@/components/entities/hooks/use-entities-query-params';
import { useCursorPagination } from '@/hooks/use-pagination';
import useSession from '@/hooks/use-session';
const useEntities = (kind, defaultFilters) => {
  const $ = _c(35);
  const {
    authHeaders,
    isLive
  } = useSession();
  const {
    requestParams,
    push,
    values
  } = useEntitiesQueryParams();
  let cursor;
  let pageSize;
  let params;
  if ($[0] !== requestParams) {
    ({
      cursor,
      pageSize,
      ...params
    } = requestParams);
    $[0] = requestParams;
    $[1] = cursor;
    $[2] = pageSize;
    $[3] = params;
  } else {
    cursor = $[1];
    pageSize = $[2];
    params = $[3];
  }
  let t0;
  if ($[4] !== authHeaders || $[5] !== defaultFilters || $[6] !== isLive || $[7] !== kind || $[8] !== requestParams) {
    t0 = ["entities", kind, requestParams, authHeaders, defaultFilters, isLive];
    $[4] = authHeaders;
    $[5] = defaultFilters;
    $[6] = isLive;
    $[7] = kind;
    $[8] = requestParams;
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  let t1;
  if ($[10] !== cursor || $[11] !== defaultFilters || $[12] !== kind || $[13] !== pageSize || $[14] !== params) {
    t1 = async () => {
      const response = await postEntitiesSearch({
        body: {
          pagination: {
            cursor,
            pageSize
          },
          ...params,
          ...defaultFilters,
          kind
        }
      });
      return response.data;
    };
    $[10] = cursor;
    $[11] = defaultFilters;
    $[12] = kind;
    $[13] = pageSize;
    $[14] = params;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  const t2 = !!kind;
  let t3;
  if ($[16] !== t0 || $[17] !== t1 || $[18] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[16] = t0;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  const query = useQuery(t3);
  const t4 = query?.data?.meta?.next ?? 0;
  let t5;
  if ($[20] !== values.cursor) {
    t5 = values.cursor ? values.cursor.split(",") : [];
    $[20] = values.cursor;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== push) {
    t6 = newCursor => push({
      cursor: newCursor
    });
    $[22] = push;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== pageSize || $[25] !== t4 || $[26] !== t5 || $[27] !== t6) {
    t7 = {
      next: t4,
      cursor: t5,
      onChange: t6,
      pageSize
    };
    $[24] = pageSize;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  const pagination = useCursorPagination(t7);
  let t8;
  if ($[29] !== query.error) {
    t8 = query.error ? getErrorMessage(query.error) : undefined;
    $[29] = query.error;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== pagination || $[32] !== query || $[33] !== t8) {
    t9 = {
      ...query,
      errorMessage: t8,
      pagination
    };
    $[31] = pagination;
    $[32] = query;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  return t9;
};
export default useEntities;